module.exports = __webpack_public_path__ + "img/mobile-30.7c98de21.png";